"use client";

import UIStateProvider from "./state-context";
import UserProvider from "./user-context";

export default function ContextProvider({children}:{children: React.ReactNode}){
    return(
        <UserProvider>
            <UIStateProvider>
                {children}
            </UIStateProvider>
        </UserProvider>
    )
}